import axios, {AxiosResponse} from 'axios'
import {
  AddGiftWrapPayload,
  ApiError,
  ExpressShippingEstimationPayload,
  ExpressShippingEstimationResponse,
  OmniChannelShippingInfoPayload,
  Order,
  OrderDetails,
  RemoveGiftWrapPayload,
  RemoveItemPayload, ShippingMethodsResponse,
  StoreDetails,
  TollShippingAvailabilityPayload,
  TollShippingAvailabilityResponse,
  ZipCodeShippingEstimationResponse,
} from '@interfaces/checkout'
import wcs from '@libs/wcs'
import {DataPrescriptionType} from '@store/types/prescription.types'
import {PrescriptionAddPayload} from '@interfaces//prescription'


export const getCartData = async ({
    storeId,
    catalogId,
    langId,
    timeStamp,
    }:{
    storeId: string,
    catalogId: string,
    langId: string,
    timeStamp: number,
}):Promise<AxiosResponse<Order> | undefined> => {
    try {
        return await axios
        .get(`/wcs/resources/store/${storeId}/cart/sgh/@self?catalogId=${catalogId}&langId=${langId}&storeId=${storeId}&_=${timeStamp}`)
    } catch (error) {
        console.error('Error getting cart data:', error)
    }
}
export const addItemToCart = async (payload:{
    [key: string]: string | number | boolean
}):Promise<AxiosResponse<OrderDetails> | undefined> => {
  try {
    return await axios
      .post(
        '/webapp/wcs/stores/servlet/AjaxOrderChangeServiceItemAdd',
        payload,
          {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
          },
      )
  } catch (error) {
    console.error('add item to cart api error:', error)
  }
}

export const addItemToRxCart = async (payload:DataPrescriptionType):Promise<AxiosResponse<any> | undefined> => {
  const hostname = window.location.hostname
  const { storeId } = wcs.getStoreConfig()
  try {
    return await axios
      .post(
        `https://${hostname}/wcs/resources/store/${storeId}/rx/cart`,
        payload,
        {headers: {'Content-Type': 'application/json; charset=UTF-8'}}
      )
  } catch (error) {
    console.error('add to rx cart api error:', error)
  }
}


export const addToBagDataCalculate = async ({
  storeId,
  langId,
  orderItemId,
}: {
  storeId: string,
  langId: string,
  orderItemId: string,
}) => {
  const payload = {
    storeId,
    langId,
    updatePrices: '1',
    orderId: orderItemId,
    calculationUsage: '-1,-2,-3,-4,-5,-6,-7',
  }
  try {
    return await axios
      .post(
        '/webapp/wcs/stores/servlet/AjaxOrderCalculate',
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
  } catch (error) {
    console.error('Error calculating cart data:', error)
  }
}

export const fetchShippingMethods = async ({ storeId,zipCode }: { storeId: string,zipCode?:string }): Promise<AxiosResponse<ShippingMethodsResponse> | undefined> => {
  const { langId } = wcs.getStoreConfig()
  try {
    return await axios.get(
      `/wcs/resources/store/${storeId}/cart/sgh/@self/shipping_info/${zipCode}`,
      {
        params: {
          langId: langId,
          _: Date.now(),// cache-busting parameter
        },
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0',
        },
        withCredentials: true, // Include cookies if needed
      }
    )
  } catch (error) {
    console.error('get shipping methods api error:', error)
    throw error
  }
}

export const updateOrderShippingInfo = async ({
  storeId,
  langId,
  catalogId,
  shipModeId,
}: {
  storeId: string,
  langId: string,
  catalogId: string,
  shipModeId: string,
}) => {
  const payload = {
    storeId,
    langId,
    catalogId,
    orderId: '.',
    calculationUsage: '-1,-2,-3,-4,-5,-6,-7',
    allocate: '***',
    backorder: '***',
    remerge: '***',
    check: '*n',
    doInventory: 'N',
    shipModeId,
  }
  try {
    return await axios
      .post(
        '/webapp/wcs/stores/servlet/AjaxOrderChangeServiceShipInfoUpdate',
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
  } catch (error) {
    console.error('update shipping method api error:', error)
  }
}

export const addGiftWrapToCartItem = async (payload: AddGiftWrapPayload) => {
  try {
    return await axios.post(
      '/webapp/wcs/stores/servlet/AjaxOrderChangeServiceShipInfoUpdate',
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  } catch (error) {
    console.error('update gift wrap api error:', error)
  }
}

export const removeGiftWrapFromCartItem = async (payload: RemoveGiftWrapPayload) => {
  try {
    return await axios.post(
      '/webapp/wcs/stores/servlet/AjaxOrderChangeServiceItemUpdate',
      payload,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'accept: text/plain, */*; q=0.01',
        },
      }
    )
  } catch (error) {
    console.error('remove gift wrap api error:', error)
  }
}


export const removeItemFromCart = async (payload:RemoveItemPayload):Promise<AxiosResponse<any> | undefined> => {
  const hostname = window.location.hostname
  try {
    return await axios
      .post(
        `https://${hostname}/webapp/wcs/stores/servlet/AjaxOrderChangeServiceItemDelete`,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
  } catch (error) {
      console.error('remove item from cart api error:', error)
  }
}

export const addPrescription = async (payload:PrescriptionAddPayload):Promise<AxiosResponse<any> | undefined> => {
  try {
    const {storeId} = wcs.getStoreConfig()
    return await axios
      .post(
        `/wcs/resources/store/${storeId}/prescription`,
        payload,
      )
  } catch (error) {
    console.error('add prescription to cart api error:', error)
  }
}

// This API is the same of Wcs service OrderItemAddressShipMethodUpdate
export const updateOrderOmniChannelShippingInfo = async (payload:OmniChannelShippingInfoPayload):Promise<AxiosResponse<OmniChannelShippingInfoPayload> | undefined> => {
  try {
    return await axios
      .post(
        '/webapp/wcs/stores/servlet/AjaxSGHOrderOmniChannelShippingInfo',
        payload,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'accept: text/plain, */*; q=0.01',
          },
        }
      )
  } catch (error) {
    console.error('omnichannel order shipping info data error:', error)
  }
}
export const estimateExpressShipping = async (payload:ExpressShippingEstimationPayload):Promise<AxiosResponse<ExpressShippingEstimationResponse> | ApiError | undefined> => {
  try {
    return await axios
      .post(
        '/webapp/wcs/stores/servlet/AjaxSGHExpressShippingDateEstimation',
        payload,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'accept: text/plain, */*; q=0.01',
          },
        }
      )
  } catch (error) {
    console.error('express shipping estimation error:', error)
  }
}

export const findPhysicalStoresWithInventoryForProduct = async (payload:any):Promise<AxiosResponse<StoreDetails> | string | undefined> => {
  try {
    return await axios
      .post(
        'AjaxSGHFindPhysicalStoresWithInventoryForProduct',
        payload,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'accept: text/plain, */*; q=0.01',
          },
        }
      )
  } catch (error) {
    console.error('find physical store availability error:', error)
  }
}


export const addStoreToFavorites = async (payload:{
  storeId: string,
  storeLocId: string,
}):Promise<AxiosResponse<{
  status: string,
  storeLocationId: string | number | null,
}> | undefined> => {
  const {storeId,storeLocId} = payload
  try {
    return await axios
      .post(
        `/wcs/resources/store/${storeId}/favorite/storeLocId/${storeLocId}/addFavoriteStore`,
      )
  } catch (error) {
    console.error('add store to favorite error:', error)
  }
}

export const removeStoreFromFavorites = async (payload:{
  storeId: string,
  storeLocId: string,
}):Promise<AxiosResponse<{
  status: string,
}> | undefined> => {
  const {storeId,storeLocId} = payload
  try {
    return await axios
      .delete(
        `/wcs/resources/store/${storeId}/favorite/storeLocId/${storeLocId}/removeFavoriteStore`,
      )
  } catch (error) {
    console.error('add store to favorite error:', error)
  }
}

export const calculateTaxByZipcode = async ({
  storeId,
  catalogId,
  langId,
  orderId,
  zipcode,
}: {
  storeId: string,
  catalogId: string,
  langId: string,
  orderId: string,
  zipcode: string,
}): Promise<AxiosResponse<any> | undefined> => {
  const payload = {
    storeId,
    catalogId,
    langId,
    orderId,
    zipcode,
  }
  try {
    return await axios.post(
      '/webapp/wcs/stores/servlet/ApplyCalculationTaxOrder',
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  } catch (error) {
    console.error('Error calculating tax by zipcode:', error)
  }
}

// This API is the same of Wcs service OrderItemUpdateEstimatedDate
export const updateEstimatedDate = async ({
  storeId,
  catalogId,
  langId,
  orderId,
}: {
  storeId: string,
  catalogId: string,
  langId: string,
  orderId: string,
}): Promise<AxiosResponse<{
  date:string,
  storeId: string,
  catalogId: string,
  langId: string,
  orderId: string,
  estimateDate:string[]
}> | undefined> => {
  const payload = {
    storeId,
    catalogId,
    langId,
    orderId,
  }
  try {
    return await axios.post('/webapp/wcs/stores/servlet/EstimatedDeliveryDateCmd', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (error) {
    console.error('Error updating estimated date:', error)
  }
}


export const estimateByZipCode = async ({
  storeId,
  orderId,
  zip,
}: {
  storeId: string,
  orderId: string,
  zip: string,
}): Promise<
  | AxiosResponse<ZipCodeShippingEstimationResponse>
  | undefined
> => {
  const payload = {
    storeId,
    orderId,
    zip,
  }
  try {
    return await axios.post(
      '/webapp/wcs/stores/servlet/AjaxSGHZipCodeDeliveryEstimation',
      payload,
      {
        headers: {
          'Accept': '*/*',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      }
    )
  } catch (error) {
    console.error('update shipping method api error:', error)
  }
}

export const estimateDeliveryDateByZipCode = async (payload: {
  storeId: string,
  date: string,
  orderId: string,
  shipModeId: number,
  slot: string,
  zip: string,
}): Promise<
  | AxiosResponse<{
      date: string,
      estimatedDeliveryDate: string,
    }>
  | undefined
> => {
  const { storeId,...rest } = payload
  try {
    return await axios.post(`/wcs/resources/store/${storeId}/zipcodeedd/estimate`,rest,{
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
      },
    })
  } catch (error) {
    console.error('delivery time estimation error:', error)
  }
}

export const checkTollShippingAvailability = async (payload: TollShippingAvailabilityPayload): Promise<
  AxiosResponse<TollShippingAvailabilityResponse> | undefined
> => {
  try {
    return await axios.post(
      '/webapp/wcs/stores/servlet/AjaxSGHTollShippingAvailability',
      payload,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    )
  } catch (error) {
    console.error('Toll shipping availability API error:', error)
  }
}
